import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-posizioni-ricerca',
  templateUrl: './posizioni-ricerca.component.html',
  styleUrls: ['./posizioni-ricerca.component.css']
})
export class PosizioniRicercaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
